<template>
    <div class="t_dropdown">
        <div class="t_dropdown__label input" @click.stop="showDropdown = !showDropdown">
            <template v-if="selected"><span class="text-primary">{{ selected }}</span></template><template v-else><span class="placeholder-text">EUR</span></template> <img class="t_dropdown__arrow" v-bind:class="{ t_up: showDropdown }" src="/img/dropdown-arrow.svg" alt="">
        </div>
        <div class="t_dropdown__menu t_dropdown__menu__full" v-bind:class="{ t_show: showDropdown }" v-if="showDropdown" v-click-outside="onClickOutside">
            <a v-for="(currency, index) in options" :key="index" @click="update(currency)">{{ currency }}</a>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            options: Array,
            selected: ''
        },
        data() {
            return {
                showDropdown: false,
            }
        },
        methods: {
            onClickOutside() {
                if (this.showDropdown) {
                    this.showDropdown = false;
                }
            },
            update: function(value) {
               this.$emit('updated', value);
               this.showDropdown = false;
            }
        }
    }
</script>